import { WifiOff } from 'lucide-react'
import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'

export function OfflineScreen({ onRetry }: { onRetry: () => void }): ReactElement {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-center">
      <WifiOff aria-hidden="true" className="text-muted-foreground size-10" />
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">You're offline</h1>
        <p className="text-muted-foreground">Check your connection and try again.</p>
      </div>
      <Button onClick={onRetry}>Retry</Button>
    </div>
  )
}
